// A reply belongs to one account/device/screen/query revision. Returning to an
// earlier identity must not revive a request from that earlier visit.
export function requestScope() {
  let identity, revision=0;
  return {
    select(next) { if(next!==identity){identity=next;revision++;} },
    invalidate() { revision++; },
    capture() { const run=revision;return ()=>run===revision; },
  };
}
